<template>
  <div>
    <ag-grid-vue
      class="ag-theme-alpine"
      style="height: 20vh"
      :columnDefs="columnDefs"
      :defaultColDef="defaultColDef"
      :rowData="filteredItems"
      :gridOptions="gridOptions"
      :undoRedoCellEditing="true"
      @grid-ready="onGridReady"
      :frameworkComponents="frameworkComponents"
      @cellClicked="onRowClicked"
      :enableCellTextSelection="true"
      :ensureDomOrder="true"
    ></ag-grid-vue>
    <div class="text-center">
      <v-pagination
        v-model="page"
        total-visible="7"
        :length="nbnDataOptions.totalPages"
        prev-icon="mdi-menu-left"
        next-icon="mdi-menu-right"
        @input="paginationChange"
      ></v-pagination>
    </div>
  </div>
</template>

<script>
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-alpine.css";
import { AgGridVue } from "ag-grid-vue";

export default {
  name: "session-auth-detail",
  props: {
    username: { type: String },
    nbnOrderId: { type: String },
    startDate: { type: String, default: null },
    endDate: { type: String, default: null }
  },
  components: { AgGridVue },
  data: () => ({
    defaultColDef: {
      sortable: true,
      filter: true,
      resizeable: true
    },
    paging: {
      pageNo: 1,
      pageSize: 10
    },
    nbnDataOptions: {},
    page: 1,
    currentPage: 1,
    items: null,
    columnDefs: null,
    gridOptions: {},
    frameworkComponents: null,
  }),
  mounted() {
    let vm = this;
    vm.gridApi = vm.gridOptions.api;
    vm.gridColumnApi = vm.gridOptions.columnApi;
  },
  beforeMount() {
    let vm = this;
    vm.gridOptions = {};
    vm.columnDefs = [
      {
        headerName: "Date Range",
        field: "dateRange",
        sortable: true,
        filter: true,
      },
      {
        headerName: "Ip",
        field: "ip",
        sortable: true,
        filter: true,
      },
      {
        headerName: "Session Id",
        field: "sessionId",
        sortable: true,
        filter: true,
      },
      {
        headerName: "Download(MB)",
        field: "downloadUsage",
        sortable: true,
        filter: true,
      },
      {
        headerName: "Upload(MB)",
        field: "uploadUsage",
        sortable: true,
        filter: true,
      }
    ];

    vm.defaultColDef = {
      autoHeight: true,
    };
    vm.getAuthSession();
  },
  computed: {
    filteredItems: function () {
      let vm = this;
      return vm.items;
    },
  },
  methods: {
    onGridReady(args) {
      let vm = this;
      vm.gridApi = args.api;
    },
    onRowClicked(args) {
      var payload = { quoteID: args.data.quoteId };
    },
    getAuthSession(){
      let vm =this;
      vm.items = [];
      if(vm.username != null && vm.username !== "")
      {
        var radiusStatusPayload = {
          radiusUsername: vm.username,
          nbnOrderId:vm.nbnOrderId,
          pageSize: vm.paging.pageSize,
          pageNumber: vm.paging.pageNo,
        }

        if (vm.startDate) {
          radiusStatusPayload.startDate = vm.startDate;
        }
        if (vm.endDate) {
          radiusStatusPayload.endDate = vm.endDate;
        }

        vm.getServiceRadiusAuthDetails(radiusStatusPayload)
          .then((data) => {
            vm.items = data.items;
            vm.nbnDataOptions = data;
            vm.gridApi.sizeColumnsToFit();
          })
          .catch(() => {});
      }
    },
    paginationChange(val) {
      this.paging.pageNo = val;
      this.getAuthSession();
    },
  },
  watch: {
    startDate() {
      this.paging.pageNo = 1;
      this.page = 1;
      this.getAuthSession();
    },
    endDate() {
      this.paging.pageNo = 1;
      this.page = 1;
      this.getAuthSession();
    }
  }
}
</script>

<style scoped>

</style>
